export default __webpack_public_path__ + "static/Slider-e3be275ea05dd2b7ec81587f514ec9a9.webm";